import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules'; // Import modules
import img1 from '../../Assets/Images/Car-img.png';
import img2 from '../../Assets/Images/Car-img1.png';
import img3 from '../../Assets/Images/Car-img2.png';
import img4 from '../../Assets/Images/car-img3.png';
import '../../Assets/CSS/ImageCarousel.css';
import { useNavigate, useParams } from 'react-router-dom';
import Login from '../auth/login/Login';
import axios from 'axios';
import Cookies from 'js-cookie';
import { getCookie } from '../auth/login/GetCookie';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const images = [img1, img2, img3,img4];
const SkeletonSlide = () => (
  <div className="swiper-slide-container">
    <Skeleton
      height={263}
      width={546}
      borderRadius={12}
      style={{ margin: 'auto' }}
    />
  </div>
);

const BannerCarousel = ({ isAuthenticated }) => {
   const [showLoginModal, setShowLoginModal] = useState(false);

   const navigate = useNavigate(); // React Router hook
 const [product, setProduct] = useState([]);
 const [products, setProducts] = useState([]);
  const [topProductsLoading, setTopProductsLoading] = useState(true);
const [singleProductLoading, setSingleProductLoading] = useState(true);

  const [error, setError] = useState(null);
    const { productId } = useParams(); // Get productId from URL params


        const handleCloseLogin = () => {
        // Close login modal
        setShowLoginModal(false);

    }


     const fetchTopProducts = async () => {
      try {
        const token = getCookie("token");
      

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/top-per-seller`,

        );

        setProducts(response.data);
        console.log("product Banner : ",response.data)
      } catch (err) {
        setError(err.message);
      } finally {
         setTopProductsLoading(false);
      }
    };


      

    
  const handleImageClick = (clickedProductId) => {

      if (!isAuthenticated) {
            setShowLoginModal(true);
            return;
        }
    // navigate('/productdetail/5'); // Navigate to the desired route
     navigate(`/productdetail/${clickedProductId}`);
  };



   useEffect(() => {
  

    fetchTopProducts();
    // fetchSingleProduct()
     setSingleProductLoading(false)
  }, []);

 





    

if (topProductsLoading || singleProductLoading) {
  return (
    <div className="container BannerCarouseConatiner">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        loop={true}
        spaceBetween={10}
        centeredSlides={true}
        speed={3000}
        className="mySwiperBanner"
        slidesPerView={1}
      >
        {[...Array(3)].map((_, index) => (
          <SwiperSlide key={index}>
            <SkeletonSlide />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
  if (error) return <div>Error: {error}</div>;

    // Create an array of slides with both image and productId
  // const slides = products.reduce((acc, product) => {
  //   if (product.bannerImageUrls) {
  //     Object.values(product.bannerImageUrls).forEach(url => {
  //       if (url && url !== "string") {
  //         acc.push({
  //           url,
  //           productId: product.productId
  //         });
  //       }
  //     });
  //   }
  //   return acc;
  // }, []);


  // Create an array of slides with banner images and productId
const slides = products.reduce((acc, product) => {
  // Check if bannerImageUrls exists and has at least one image
  if (product.bannerImageUrls && Object.keys(product.bannerImageUrls).length > 0) {
    // Get the first banner image URL
    const firstBannerUrl = Object.values(product.bannerImageUrls)[0];
    
    // Validate the URL before adding to slides
    if (firstBannerUrl && firstBannerUrl !== "string") {
      acc.push({
        url: firstBannerUrl,
        productId: product.productId,
        alt: `${product.productName || 'Product'} - Banner`, // Fallback if no name
        width: '546px', // Standard banner width
        height: '263px' // Standard banner height
      });
    }
  }
  return acc;
}, []);



  
  return (
    <div className="container BannerCarouseConatiner ">
      {showLoginModal && (<Login onClose={handleCloseLogin} loginopen={showLoginModal} />
            )}
      {slides.length > 0 && (
      <Swiper
        modules={[Navigation, Pagination, Autoplay]} // Include necessary modules
        navigation={{ clickable: true, prevEl: '.custom-prev', nextEl: '.custom-next' }} // Enable navigation (next/prev buttons)
        pagination={{ clickable: true,el:'.custom-pagination'}} // Enable pagination with clickable dots
        autoplay={{ delay: 3500, disableOnInteraction: false }} // Enable autoplay
        loop={true} // Enable looping of slides
        spaceBetween={10} // Space between slides
        centeredSlides={true}
        speed={3000}// Center slides
        className="mySwiperBanner" // Swiper class name for styling

      >
        {/* Swiper slides with images */}
        {/* {bannerImages.map((image, index) => (
           */}
           {slides.map((slide, index) => (
          <SwiperSlide key={index} className='swiper-slide-container'>
          <img
              src={slide.url}
              alt={`Banner ${index + 1}`}
              className=" img-fluid object-fit-cover Banner-Img"
              style={{cursor:'pointer'}}
              //  onClick={handleImageClick} // Handle click
              onClick={() => handleImageClick(slide.productId)}
            />
          </SwiperSlide>
          
        ))}
        
        {/* Custom Navigation Buttons */}
        <div className="swiper-button-prev custom-prev"></div>
        <div className="swiper-button-next custom-next"></div>
          {/* custom pagination */}
        <div  className="custom-pagination"></div>
      </Swiper>
      )}                
      
    </div>
  )
};

export default BannerCarousel;
